import type { AppDispatch } from '/business/shared/state/store';
import normaliseError, { toNormaliseErrorInput } from '/shared/functions/normaliseError';

export type ModalMetadataValue =
  | string
  | number
  | bigint
  | symbol
  | boolean
  | object
  | null
  | undefined
  | ((...args: never[]) => void | Promise<void>);

export interface ModalConfig {
  name: string;
  isBlocking?: boolean;
  isBlockingWithCloseButton?: boolean;
  rightAlign?: boolean;
  pageReplace?: boolean;
  title?: string | { displayName: string } | null;
  metadata?: Record<string, ModalMetadataValue>;
}

export type ModalValue = string | ModalConfig;

export const showModal = (modal: ModalValue) => (dispatch: AppDispatch) => {
  dispatch({ type: 'SHOW_MODAL_STARTED' });
  try {
    dispatch({ type: 'SHOW_MODAL_FULFILLED', modal });
  } catch (error) {
    dispatch({ type: 'SHOW_MODAL_REJECTED', error: normaliseError(toNormaliseErrorInput(error), 'MODAL') });
  }
};

export const closeModal =
  (modal: ModalValue | null = null) =>
  (dispatch: AppDispatch) => {
    dispatch({ type: 'CLOSE_MODAL_STARTED' });
    try {
      dispatch({ type: 'CLOSE_MODAL_FULFILLED' });
    } catch (error) {
      dispatch({ type: 'CLOSE_MODAL_REJECTED', error: normaliseError(toNormaliseErrorInput(error), 'MODAL') });
    }
  };

export default {
  showModal,
  closeModal,
};
